import { render, staticRenderFns } from "./widgetTagItem.vue?vue&type=template&id=30a4f6dd&scoped=true"
import script from "./widgetTagItem.vue?vue&type=script&lang=js"
export * from "./widgetTagItem.vue?vue&type=script&lang=js"
import style0 from "./widgetTagItem.vue?vue&type=style&index=0&id=30a4f6dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a4f6dd",
  null
  
)

export default component.exports